// For each view you need to create a function to add it to the state provider
function initProdStates($stateProvider) {

    $stateProvider.state('home.sampleElementCreate', {
        url : '/sampleElement/create',
        templateUrl : "views/prod/sampleElement.detail.html",
        data : {
            type : 'create',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.sampleElementList', {
        url : "/sampleElement/list",
        templateUrl : "views/prod/sampleElement.list.html",
        data : {
            type : 'search',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.sampleElementUpdate', {
        url : '/sampleElement/:id',
        templateUrl : "views/prod/sampleElement.detail.html",
        data : {
            type : 'update',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.regulationList', {
        url : "/regulation/list",
        templateUrl : "views/prod/regulation.list.html",
        data : {
            type : 'search',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.regulationHome', {
        url : '/regulation/:id/home',
        templateUrl : "views/prod/regulation.home.html",
        controller: "regulationHomeCtrl",
        resolve: {
        	regulationHomeDataresolve: function($stateParams, regulationService){
        		return regulationService.getRegulation($stateParams.id);
        	}
        },
        data : {
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.regulationCreate', {
        url : '/regulation/create',
        templateUrl : "views/prod/regulation.detail.html",
        data : {
            type : 'create',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.regulationUpdate', {
        url : '/regulation/:id',
        templateUrl : "views/prod/regulation.detail.html",
        data : {
            type : 'update',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.regulationAnalysisList', {
        url : "/regulation/:idRegulation/Analysis",
        templateUrl : "views/prod/regulation.analysis.list.html",
        data : {
            type : 'search',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.AnalysisList', {
        url : "/regulation/Analysis/List",
        templateUrl : "views/prod/analysis.list.html",
        data : {
            type : 'search',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.analysisCreate', {
        url : "/regulation/:idRegulation/Analysis/create",
        templateUrl : "views/prod/regulation.analysis.detail.html",
        data : {
            type : 'create',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.analysisUpdate', {
        url : "/regulation/:idRegulation/Analysis/:idAnalysis/update",
        templateUrl : "views/prod/regulation.analysis.detail.html",
        data : {
            type : 'update',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.regulationTechniqueList', {
        url : "/regulation/:idRegulation/analysis/:idAnalysis/technique",
        templateUrl : "views/prod/regulation.technique.list.html",
        data : {
            type : 'search',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.TechniqueList', {
        url : "/technique/List",
        templateUrl : "views/prod/technique.list.html",
        data : {
            type : 'search',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.techniqueCreate', {
        url : "/regulation/:idRegulation/analysis/:idAnalysis/technique/create",
        templateUrl : "views/prod/regulation.technique.detail.html",
        data : {
            type : 'create',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.TechniqueCreateS', {
        url : "/technique/create",
        templateUrl : "views/prod/technique.detail.html",
        data : {
            type : 'create',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.techniqueUpdate', {
        url : "/regulation/:idRegulation/analysis/:idAnalysis/technique/:idTechnique/type/:type/update",
        templateUrl : "views/prod/regulation.technique.detail.html",
        data : {
            type : 'update',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.techniqueUpdateS', {
        url : "/technique/:idTechnique/update",
        templateUrl : "views/prod/technique.detail.html",
        data : {
            type : 'update',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.productCategoryCreate', {
        url : '/productcategory/create?parentId&parentName',
        templateUrl : "views/prod/productCategory.detail.html",
        data : {
            type : 'create',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.productCategoryList', {
        url : "/productcategory/list",
        templateUrl : "views/prod/productCategory.list.html",
        data : {
            type : 'search',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.productCategoryUpdate', {
        url : '/productcategory/:id',
        templateUrl : "views/prod/productCategory.detail.html",
        data : {
            type : 'update',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.productCreate', {
        url : '/product/create',
        templateUrl : "views/prod/product.detail.html",
        data : {
            type : 'create',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.productList', {
        url : "/product/list",
        templateUrl : "views/prod/product.list.html",
        data : {
            type : 'search',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.productUpdate', {
        url : '/product/:id',
        templateUrl : "views/prod/product.detail.html",
        data : {
            type : 'update',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    }).state('home.productRegulation', {
        url : '/product/:id/regulation',
        templateUrl : "views/prod/productRegulation.list.html",
        controller: "productRegulationListCtrl",
        data : {
            type : 'update',
            permissions : {
                only : [ ROLE_TYPE.ADMIN.code ]
            }
        }
    });

}
